"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AdditionalHelp() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className={`relative bg-accent py-24 transition-all duration-[var(--duration-fast)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
      <div className="mx-auto max-w-screen-xl px-4">
        <div className="flex flex-col items-center gap-6 text-center">
          <h2 className="text-3xl font-semibold text-foreground-accent sm:text-4xl">
            Need Additional Help?
          </h2>
          <p className="max-w-2xl text-lg text-foreground-accent/90">
            Our dispatch team is ready to answer your questions and get you started. Return to the form or call us directly.
          </p>
          <Link to="#contact-form">
            <Button size="lg" className="mt-4 bg-primary text-foreground-primary shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:-translate-y-0.5 hover:bg-primary-hover hover:shadow-strong focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary">
              Back to Form
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}